module.exports = __webpack_public_path__ + "assets1775130923925/img/lan2.eddb60b0.png";